import { companyInfo, heroImages } from "@/mocks/home";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import contact from "@/assets/contact.png";

export default function Contact() {
  const { ref: titleRef, isVisible: titleVisible } = useScrollAnimation();
  const { ref: contentRef, isVisible: contentVisible } = useScrollAnimation();

  return (
    <section id="contact" className="relative py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={contact}
          alt="物流トラック"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-background-50/85"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-7xl mx-auto">
          <div
            ref={titleRef}
            className={`text-center mb-12 md:mb-16 transition-all duration-700 ${titleVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
              }`}
          >

            <h2 className="flex items-center justify-center gap-4 md:gap-8 text-2xl md:text-4xl lg:text-5xl font-black font-heading text-foreground-50">
              <span className="w-16 md:w-52 h-px bg-gradient-to-l from-primary-500 to-transparent" />
              お問い合わせ
              <span className="w-16 md:w-52 h-px bg-gradient-to-r from-primary-500 to-transparent" />
            </h2>
            <p className="text-primary-400 text-sm">CONTACT US</p>

            <p className="text-foreground-400 text-base md:text-lg max-w-2xl mx-auto mt-4">
              24時間受付中。<br />まずはお気軽にご相談ください。
            </p>
          </div>

          <div
            ref={contentRef}
            className={`max-w-xl mx-auto transition-all duration-700 ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
              }`}
          >
            <div className="bg-background-100 border border-background-300/30 rounded-xl p-6 md:p-8">
              <h3 className="text-foreground-50 text-2xl  text-center font-bold font-heading mb-6">お電話でのお問い合わせ</h3>
              <a
                href={`tel:${companyInfo.phone}`}
                className="flex items-center gap-4 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-xl p-6 transition-colors duration-200 mb-6"
              >
                <div className="w-14 h-14 rounded-full bg-background-50/20 flex items-center justify-center">
                  <i className="ri-phone-line text-2xl"></i>
                </div>
                <div>
                  <p className="text-sm opacity-80">TEL</p>
                  <p className="text-xl md:text-3xl font-black font-heading">{companyInfo.phone}</p>
                </div>
              </a>
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-full bg-background-200 flex items-center justify-center flex-shrink-0">
                    <i className="ri-time-line text-primary-400"></i>
                  </div>
                  <div>
                    <p className="text-foreground-50 font-bold text-sm">営業時間</p>
                    <p className="text-foreground-500 text-sm">{companyInfo.hours}</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-full bg-background-200 flex items-center justify-center flex-shrink-0">
                    <i className="ri-calendar-line text-primary-400"></i>
                  </div>
                  <div>
                    <p className="text-foreground-50 font-bold text-sm">定休日</p>
                    <p className="text-foreground-500 text-sm">{companyInfo.holiday}</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-full bg-background-200 flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-primary-400"></i>
                  </div>
                  <div>
                    <p className="text-foreground-50 font-bold text-sm">所在地</p>
                    <p className="text-foreground-500 text-sm">{companyInfo.address}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}